// extracted by mini-css-extract-plugin
export default {"UsersPage":"UsersPage_UsersPage__nDaxh"};